import { Component, inject, model, signal } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-application-timeout-modal',
  imports: [],
  templateUrl: './application-timeout-modal.html',
  styleUrl: './application-timeout-modal.scss',
})
export class ApplicationTimeoutModal {
  constructor(public activeModal: NgbActiveModal) {
    setInterval(() => {
      this.timeLeft.set(this.timeLeft() - 1);
      if (this.timeLeft() <= 0) {
        this.activeModal.close(false);
      }
    }, 1000);
  }
  timeLeft = signal<number>(60);

}
